/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";

export const getDashboardData = async (payload: { start_time: string }) => {
  const res = await axios.get("/call_stats", {
    params: payload,
  });
  return res;
};

export const getCallStats = async (payload: {
  direction: string;
  limit: number;
  page: number;
  filter_by: string;
  start_time: string;
}) => {
  const res = await axios.get("/call_by_agent", {
    params: payload,
  });
  return res;
};
